import { render } from "./Ripple.vue?vue&type=template&id=0d4bd7a7&scoped=true"
import script from "./Ripple.vue?vue&type=script&lang=js"
export * from "./Ripple.vue?vue&type=script&lang=js"

import "./Ripple.vue?vue&type=style&index=0&id=0d4bd7a7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d4bd7a7"

export default script